export const _heicHeifMimeTypes = ["image/heic", "image/heif"];
